<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Dettaglio azienda gruppo
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
                 class="text-white p-3 mb-3 flex justify-between items-center">
                {{ response_message }}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <p>Azienda gruppo: <span class="font-bold">{{ azienda.nome }}</span></p>
            <div class="pt-5 flex flex-col">

                <Field field_name="Business unit">
                    <VueMultiselect
                        v-model="buAutocomplete.selection"
                        :options="buAutocomplete.options"
                        placeholder="Business unit"
                        class="next-vue-multiselect"
                        track-by="id"
                        label="nome"
                        :multiple="true"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        :close-on-select="false"
                        :clear-on-select="true"
                        @search-change="buAutocomplete.search"
                    >
                        <template v-slot:tag="{option, remove}">
                            <MultiselectOption @remove="remove(option)">
                                {{ option.nome }}
                            </MultiselectOption>
                        </template>
                    </VueMultiselect>
                </Field>
            </div>

            <div class="flex pt-3 justify-end">
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../../components/Topbar.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import ModalFigli from "@/components/ModalFigli.vue";
import NextEditor from "@/components/NextEditor.vue";
import Loading from "@/components/Loading.vue";
import Alert from '@/components/Alert.vue';
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import Checkbox from "@/components/Checkbox.vue";
import Autocomplete from "@/setup/Autocomplete";
import businessUnitsManager from "@/api/BusinessUnits";
import {aziendeGruppoBuManager, aziendeGruppoManager} from "@/api/AziendeGruppo";


@Options({
    name: 'DettaglioAziendaGruppo',
    components: {
        Checkbox,
        NextButton,
        Topbar,
        NextEditor,
        Breadcrumbs,
        ModalFigli,
        Loading,
        MultiselectOption,
        Field,
        Alert
    },

    props: {
        id: {
            type: [String, Number],
            required: true
        },
        cid: {
            type: [String, Number],
            required: true
        },
    }
})
export default class DettaglioAziendaGruppo extends Vue {
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, true))

    id!: number
    azienda = {}
    esito = false
    response_message = ''
    errors: any = {}

    created() {
        this.fetchBusinessUnit()
        this.buAutocomplete.search('', 0)
    }

    getErrors(index: string | number, prefix: string, field: string) {
        return (this.errors as any)[`${prefix}.${index}.${field}`]
    }

    fetchBusinessUnit() {
        aziendeGruppoManager.aziendaGruppo(this.id).then((response) => {
            this.azienda = response.data
        })
        aziendeGruppoBuManager.businessUnitAziendaGruppo(this.id).then((response) => {
            this.buAutocomplete.selection = response.data
        })
    }

    save() {
        this.response_message = ''
        aziendeGruppoBuManager.saveBusinessUnits(this.id, {
            bu_ids: this.buAutocomplete.selection.map((e: any) => e.id),
        }).then(() => {
            this.esito = true
            this.response_message = 'Salvataggio avvenuto corretamente'
        }).catch(() => {
            this.esito = false
            this.response_message = 'Salvataggio fallito'
        })
    }

}
</script>


<style lang="scss">

</style>
